export default function Arrow(props) {
    return (
        <svg onClick={() => props.onClick()} className={props.className} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
            {"title" in props ? 
                <title>{props.title}</title>
            : null}
            <polygon points="9.27,1.31 118.73,1.31 64,128 "/>
        </svg>
    )
}